import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Modal } from '../common/Modal';

export interface IsTestCaseModalProps {
	isOpen: boolean;
}

export function IsTestCaseModal(props: IsTestCaseModalProps) {
	const [isOpen, setIsOpen] = useState(props.isOpen);

	return (
		<Modal
			isOpen={isOpen}
			closeOnBackdropClick={true}
			header={
				<h2>
					<FormattedMessage id="testcasemodal.headline" />
				</h2>
			}
			footer={
				<button onClick={() => setIsOpen(false)}>
					<FormattedMessage id="testcasemodal.accept" />
				</button>
			}
			onClose={() => setIsOpen(false)}
		>
			<Paragraph>
				<FormattedMessage id="testcasemodal.paragraph" />
			</Paragraph>
		</Modal>
	);
}

const Paragraph = styled.p`
	text-align: left;
	margin-bottom: 2rem;
`;
